module.exports = __webpack_public_path__ + "static/media/logo_baru.116c369b.png";